import { GoPlus, GoX } from "react-icons/go";

import {
	Flex,
	Heading,
	AccordionItem,
	AccordionPanel,
	AccordionButton,
} from "@chakra-ui/react";

import type { PropsWithChildren } from "react";

interface CustomAccordionProps extends PropsWithChildren {
	label: string;
}

export const CustomAccordionItem = ({
	label,
	children,
}: CustomAccordionProps) => (
	<AccordionItem borderY="1px" borderColor="brand.mid">
		{({ isExpanded }) => (
			<>
				<AccordionButton
					as={Flex}
					cursor="pointer"
					justify="space-between"
					_hover={{ bg: "brand.mid" }}
				>
					<Heading textAlign="left" fontSize="lg">
						{label.toUpperCase()}
					</Heading>

					{isExpanded ? <GoX fontSize="12px" /> : <GoPlus fontSize="12px" />}
				</AccordionButton>
				<AccordionPanel>{children}</AccordionPanel>
			</>
		)}
	</AccordionItem>
);
